"use client"
// ThemeProviderComponent.tsx
import React from 'react';
import { useMediaQuery } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';

// Define a component that provides the custom theme using ThemeProvider
const ThemeProviderComponent: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  // Define your custom theme
  const theme = createTheme({
    // Define your theme properties here
    components: {
      MuiSelect: {
        styleOverrides: {
          select: {
            paddingLeft: '2px',
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          input: {
            paddingLeft: '2px',
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontWeight: 'bold',
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontSize: '12px',
            fontWeight: 'bold',
          },
        },
      },
      MuiTable: {
        styleOverrides: {
          root: {
            margin: '12px 0px 0px 0px',
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: '0px 1px',
          },
          head: {
            fontWeight: 'bold',
            fontSize: '12px',
            textAlign: 'center',
            padding: '5px 0px',
          },
        },
      },
      MuiTablePagination: {
        styleOverrides: {
          selectLabel: {
            fontSize: '12px',
          },
          displayedRows: {
            fontSize: '12px',
          },
          input: {
            fontSize: '12px',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: '14px',
            textTransform: 'none'
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              backgroundColor: 'orange',
            },
          },
        },
      },
    },
    palette: {
      mode: (prefersDarkMode ? 'dark' : 'light'),
      primary: {
        main: '#007bff',
      },
      secondary: {
        main: '#6c757d',
      },
    },
    typography: {
      fontFamily: 'Roboto, sans-serif',
      // Other typography styles
    },
    // Other theme properties
  });

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
};

export default ThemeProviderComponent;